<template>
  <v-list
    ><v-list-item>
      <v-list-item-content>
        <v-list-item-subtitle style="overflow: visible"
          ><v-form @submit.prevent="applyPromo" ref="promo">
            <v-combobox
              v-model="promoCode"
              @change="applyPromo"
              chips
              outlined
              prepend-inner-icon="redeem"
              dense
              hide-details
              :disabled="activePromos.length > 0"
              append-icon=""
              :error-messages="errors.promo"
              :rules="promoRules"
              label="Gift or promo code"
            >
              <template v-slot:selection="{ attrs, item, select, selected }">
                <v-chip
                  small
                  v-bind="attrs"
                  :input-value="selected"
                  style="pointer-events: all"
                  close
                  @change="select"
                  @click:close="
                    promoCode = null;
                    promoRules = [];
                    activePromos = [];
                  "
                >
                  {{ item }}
                </v-chip>
              </template></v-combobox
            >
          </v-form></v-list-item-subtitle
        >
      </v-list-item-content>
      <v-list-item-action class="align-self-start pt-0.5"
        ><SoliBtn
          color="dark"
          :loading="promoLoading"
          :disabled="activePromos.length > 0"
          @click="applyPromo"
          >Apply</SoliBtn
        ></v-list-item-action
      >
    </v-list-item></v-list
  >
</template>

<script>
export default {
  props: ["errors"],
  data() {
    return {
      promoCode: null,
      activePromos: [],
      showMessage: false,
      promoRules: [],
      promoLoading: false,
    };
  },
  methods: {
    applyPromo() {
      this.promoLoading = true;
      this.promoRules.push((v) => !!v || "Required");

      if (!this.$refs.promo.validate()) {
        this.promoLoading = false;
        return;
      }

      axios
        .get(
          route("stripe.promo", {
            promo: this.promoCode,
            products: this.prices.map((e) => e.product),
          })
        )
        .then((e) => {
          if (e.data.promo) {
            this.$page.props.errors.promo = e.data.promo;
            this.promoLoading = false;
            setTimeout(() => {
              this.promoRules = [];
              this.$page.props.errors.promo = null;
              this.promoCode = null;
            }, 3000);
          } else {
            console.log(e.data);
            this.activePromos.push(e.data);
            this.showMessage = "Promo Applied!";
            this.promoLoading = false;
          }
        });
    },
  },
};
</script>